import script from "./PartnerOnboardingFormTutorialsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerOnboardingFormTutorialsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerOnboardingFormTutorialsPage.vue?vue&type=style&index=0&id=6b87cbb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b87cbb5"]])

export default __exports__